import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { apiService } from '../services/api';
import SocialShare from '../components/SocialShare';
import SEO from '../components/SEO';
import AdBanner from '../components/AdBanner';
import AdComponent from '../components/AdComponent';
import HilltopBanner from '../components/HilltopBanner';

function ArticlePage() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const response = await apiService.getArticle(slug);
        if (response.success) {
          setArticle(response.data);
         //console.log(response.data);
         //console.log('ad_scripts:', article.ad_scripts);
        }
      } catch (error) {
        console.error('Error fetching article:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchArticle();
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div>
      </div>
    );
  }

  if (!article) {
    return (
      <div className="container mx-auto px-4 py-16 text-center">
        <h1 className="text-2xl font-bold text-slate-800 mb-4">Article Not Found</h1>
        <p className="text-slate-600">The article you're looking for doesn't exist.</p>
        <Link to="/" className="btn-primary mt-4 inline-block">
          Back to Home
        </Link>
      </div>
    );
  }

const keywordsArray = article.keywords.split(",").map(keyword => keyword.trim());
//const keywordsString =  article?.keywords ? article.keywords.join(', ') : ''; //This line is for DB fetch
const keywordsString =  keywordsArray ? keywordsArray.join(', ') : '';
//console.log("Keywords:", keywordsString);
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-cyan-50 py-8">
      <div className="container mx-auto px-4 max-w-4xl">
        <article className="bg-white rounded-2xl shadow-xl overflow-hidden">
          {/* Article Header */}
          <SEO
              title={article.title}
              description={article.meta_description}
              keywords={keywordsString}
              toolType="blog"
          />
          <div className="bg-gradient-to-r from-orange-500 to-cyan-500 p-8 text-white">
            <div className="flex items-center space-x-2 mb-4">
              {article.calculator_name && (
                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-white text-orange-600">
                  🧮 Includes Calculator
                </span>
              )}
            </div>
            <h1 className="text-4xl font-bold mb-4 dark:text-slate-200">{article.title}</h1>
            <p className="text-xl text-blue-100 mb-4">{article.meta_description}</p>
            <div className="flex items-center space-x-4 text-sm">
              <span>Published: {new Date(article.created_at).toLocaleDateString()}</span>
              {article.keywords && article.keywords.length > 0 && (
                <div className="flex space-x-2">
                  {/*article.keywords.map(keyword => (*/}
                  {keywordsArray.map(keyword => (
                    <span key={keyword} className="bg-white bg-opacity-20 px-2 py-1 rounded">
                      #{keyword}
                    </span>
                  ))}
                </div>
              )}
            </div>
            {/*
            <div className="mt-8">
              <AdBanner adKey="857d3637cfc0b322e60f1c5c2a864a62" width={320} height={50} />   
            </div>  */
            }
          </div>
                 
          {/* Article Content */}
          <div className="article-content p-8">
            <div 
              className="prose prose-lg max-w-none mb-8"
              dangerouslySetInnerHTML={{ __html: article.content }}
            />
            {/* Calculator Section */}
            { /*<div className="mt-8 p-6 bg-gradient-to-r from-green-50 to-blue-50 rounded-lg border border-green-200">*/ 
              }
              
            {article.calculator_name && (
              <div className="mt-8 p-6 artcle-calcy-box"> 
                <h3 className="text-2xl font-bold text-slate-800 dark:text-slate-100 mb-4 flex items-center">
                  <span className="w-8 h-8 bg-green-500 rounded-lg flex items-center justify-center text-white mr-3">
                    ∑
                  </span>
                  Try the {article.calculator_name}
                </h3>
                <p className="text-slate-600 mb-4 dark:text-slate-200">
                  Use our interactive calculator to apply what you've learned:
                </p>
                <div className="flex space-x-4">
                  <Link 
                    to={`/calculators/${article.calculator_slug}`}
                    className="btn-secondary"
                  >
                    Open Calculator
                  </Link>
                  <Link 
                    to="/calculators"
                    className="btn-primary"
                  >
                    View All Calculators
                  </Link>
                </div>
              </div>
            )}

            {/* Ad Scripts Section */}
            {/*{article.ad_scripts && (
              <div className="mt-8 p-4 bg-gray-100 rounded-lg"
                 dangerouslySetInnerHTML={{ __html: article.ad_scripts }} 
              />
            )}*/}
           <div className="flex justify-center mt-8">
              {/* <AdComponent />*/ }
               <HilltopBanner />
           </div>  

          </div>

          {/* Article Footer */}
          {/* <div className="bg-slate-50 px-8 py-6 border-t border-slate-200"> */ }
          <div className="article-footer px-8 py-6">
            {/* Add Social Share here */}
            <div className="mb-6">
              <SocialShare 
                url={window.location.href}
                title={article.title}
                description={article.meta_description}
              />
            </div>

            <div className="flex justify-between items-center">
              <Link to="/" className="text-orange-500 hover:text-orange-600 font-medium">
                ← Back to Home
              </Link>
              <Link to="/calculators" className="btn-primary">
                Explore Calculators
              </Link>
            </div>
          </div>
        </article>
      </div>
    </div>
  );
}

export default ArticlePage;